import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WaterTransferDocumentServiceStore } from '@app/services/water-transfer-document/store/water-transfer-document-service.store';

@Component({
    selector: 'app-utility-transfer-section',
    template: `
        <div class="u-margin-bottom-triple">
            <h1 class="u-font-size-28 u-font-weight-semibold u-margin-bottom">{{ 'DASHBOARD.UTILITY_TRANSFER.TITLE' | translate }}</h1>
            <app-reading-meters class="block mb-4"></app-reading-meters>
            @if (waterTransferDocumentServiceStore.waterTransferDocumentService()?.active) {
                <smvd-app-water-transfer-card class="block mb-4"></smvd-app-water-transfer-card>
            }
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UtilityTransferSectionComponent {
    public readonly waterTransferDocumentServiceStore = inject(WaterTransferDocumentServiceStore);
}
